 import {useNavigate} from "react-router-dom"; 
import Button from '@mui/material/Button'; 
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography'; 
import MoreVertIcon from '@mui/icons-material/MoreVert'; 
import ColletionCardv2 from './ColletionCardv2';   
import colletionsnew  from '../config/colletionsnew.json';
import { toast } from "react-toastify";

export default function ColletionsNew() {   
     const mchainid = 137; 
   // console.log('nfts:',nfthot_2);   
  const navigate = useNavigate();
  const newhandleClick = () => {
    toast.success("comming soon...."); 
    //  navigate("/collectionsv2", { replace: true });       
  } 

  return (
    <Container>   
      <Stack direction="row" alignItems="center" justifyContent="space-between"  mb={5} mt={5}>
        <Typography variant="h5"  >
         Newest Collections 
        </Typography> 
        <Button  onClick={newhandleClick}  variant="outlined"   startIcon={<MoreVertIcon   />}>
         more...
        </Button>
      </Stack> 

      <Grid container spacing={3}>
        {colletionsnew && colletionsnew?.map((nft:any,index:number) => (
          <Grid key={index} xs={12} sm={6} md={3}>
            <ColletionCardv2 chainid={mchainid}  nft={nft} />
          </Grid>
        ))}
     
      </Grid> 
    </Container>
  );
}
